var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      style: _vm.wrapperStyle,
      on: {
        click: function($event) {
          return _vm.$emit("click", $event)
        }
      }
    },
    [
      _vm.item.url
        ? _c("pdf-embed", {
            class: "agreement-pdf align-" + (_vm.item.alignment || "center"),
            style: "width: " + (_vm.item.scale || 100) + "%",
            attrs: { url: _vm.item.url, "file-name": _vm.item.fileName }
          })
        : _c(
            "div",
            [
              _c(
                "v-icon",
                {
                  staticClass: "material-symbols-rounded",
                  attrs: { size: "100" }
                },
                [_vm._v("picture_as_pdf")]
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }